import {Link} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'
import Tooltip from '../../../components/Tooltip/Tooltip'

const StateBox = ({
  semiHeader,
  header,
  headerLink,
  searchParams,
  tooltip,
  description,
  className,
}: {
  semiHeader: string
  header: string
  headerLink?: string
  searchParams?: string
  tooltip?: string
  description?: string
  className?: string
}) => {
  return (
    <div className={`mb-5 ${className ? className : 'col-xl-6 '}`}>
      <div className='card border card-flush h-xl-100'>
        <div className='card-body p-7'>
          <div className='symbol symbol-50px w-40px h-40px bg-light-primary d-flex align-items-center justify-content-center mb-5'>
            <i className='icon-24'>
              <KTSVG path='/media/ad-theme-icons/blue-doller-icon.svg' />
            </i>
          </div>
          <div className='mb-5'>
            <span className='fs-6 fw-semibold'>{semiHeader}</span>
            {tooltip ? (
              <h3 className='mb-0 fw-bolder fs-2'>
                <Tooltip tooltipText={tooltip} text={header} />
              </h3>
            ) : (
              <h3 className='mb-0 fw-bolder fs-2'>
                {headerLink ? (
                  <Link
                    to={{
                      pathname: headerLink,
                      search: searchParams,
                    }}
                    target='_blank'
                    className='text-dark text-decoration-underline text-hover-primary'
                  >
                    {header}
                  </Link>
                ) : (
                  header
                )}
              </h3>
            )}
          </div>
          {description && <span className='fs-6 fw-semibold text-gray-500'>{description}</span>}
        </div>
      </div>
    </div>
  )
}

export default StateBox
